let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3PTqF")).then(() => parcelRequire('N7rTt'));